import React from 'react';
import { Section } from './ui/Section';
import { CreditCard, Download, PlayCircle, Star } from 'lucide-react';
export function HowItWorks() {
  return <Section bg="bg-brand-sand" data-id="element-71">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-brand-brown" data-id="element-72">
        ¿Cómo funciona?
      </h2>

      <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-73">
        <div className="bg-white p-6 rounded-2xl text-center shadow-sm" data-id="element-74">
          <div className="bg-brand-cream w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-75">
            <CreditCard className="w-8 h-8 text-brand-green" data-id="element-76" />
          </div>
          <h3 className="text-xl font-bold mb-3 text-brand-brown" data-id="element-77">
            1. Pago Seguro
          </h3>
          <p className="text-brand-brown-light text-lg" data-id="element-78">
            Realizas el pago seguro de $6.30 (el costo de un café).
          </p>
        </div>

        <div className="bg-white p-6 rounded-2xl text-center shadow-sm" data-id="element-79">
          <div className="bg-brand-cream w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-80">
            <Download className="w-8 h-8 text-brand-green" data-id="element-81" />
          </div>
          <h3 className="text-xl font-bold mb-3 text-brand-brown" data-id="element-82">
            2. Acceso Inmediato
          </h3>
          <p className="text-brand-brown-light text-lg" data-id="element-83">
            Recibes el acceso inmediato a la guía en formato PDF para leer en tu
            celular o tablet.
          </p>
        </div>

        <div className="bg-white p-6 rounded-2xl text-center shadow-sm" data-id="element-84">
          <div className="bg-brand-cream w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-85">
            <PlayCircle className="w-8 h-8 text-brand-green" data-id="element-86" />
          </div>
          <h3 className="text-xl font-bold mb-3 text-brand-brown" data-id="element-87">
            3. Acción Rápida
          </h3>
          <p className="text-brand-brown-light text-lg" data-id="element-88">
            Aplicas el capítulo de "Acción en 21 días" para empezar a buscar tu
            primer ingreso extra hoy mismo.
          </p>
        </div>
      </div>

      <div className="bg-white p-8 md:p-10 rounded-2xl border-l-4 border-brand-terracotta shadow-sm" data-id="element-89">
        <div className="flex gap-1 mb-6" data-id="element-90">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-brand-terracotta text-brand-terracotta" data-id="element-91" />)}
        </div>
        <p className="text-lg md:text-xl text-brand-brown-light leading-relaxed italic" data-id="element-92">
          "Este producto no se basa en teorías económicas complejas, sino en la
          economía de servicios de Estados Unidos. Cada día, miles de familias
          americanas y latinas buscan personas responsables para tareas que
          ellos no tienen tiempo de hacer. Si tú sabes hacer esas tareas y ahora
          sabes cómo aparecer frente a esos clientes usando tu celular, el
          ingreso extra es inevitable."
        </p>
      </div>
    </Section>;
}